import { render } from "./AppointmentItem.vue?vue&type=template&id=b23e969e&scoped=true"
import script from "./AppointmentItem.vue?vue&type=script&lang=js"
export * from "./AppointmentItem.vue?vue&type=script&lang=js"

import "./AppointmentItem.vue?vue&type=style&index=0&id=b23e969e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b23e969e"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QItemSection,QItemLabel,QChip,QLinearProgress});
